module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon12.dd651045.png";